module.exports = __webpack_public_path__ + "img/chixu1.8b8587e0.png";